import ActionButton from "../ActionButton";
import ErrorBoundary from "../ErrorBoundary";
import Footer from "../Footer";
import Header from "../Header";
import InterestTable from "../InterestTable";
import React from "react";
import SetNoIndex from "../../lib/SetNoIndex";
import styles from "./InterestDisclosurePage.module.css";
import usePageView from "../../lib/usePageView";
import {Container, Row, Column} from "../grid";
import {INTEREST_APR, ANNUAL_FEE} from "../DisclosureInfo/DisclosureInfo";

const strings = {
    close: "Close",
};

type Props = {
    showClose?: boolean;
};

export default function InterestDisclosurePage({showClose = false}: Props) {
    SetNoIndex();
    usePageView(document.title);
    return (
        <ErrorBoundary>
            <Header />
            <Container className={styles.container}>
                <Row>
                    <Column>
                        <InterestTable apr={INTEREST_APR} annualFee={ANNUAL_FEE} />
                        {showClose ? (
                            <ActionButton
                                className={styles.close}
                                label={strings.close}
                                onClick={window.close}
                            />
                        ) : null}
                    </Column>
                </Row>
            </Container>
            <Footer />
        </ErrorBoundary>
    );
}
